module.exports = __webpack_public_path__ + "static/media/main idea.004eadc8.mp3";